import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DuplicateAttendanceReport } from './Pages'

export const DuplicateAttendanceReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DuplicateAttendanceReport} />
    </Fragment>
)